import {isFilled, RequestLanguage} from './request.model';

export interface BilingualName {
  name?: string | null;
  nameEn?: string | null;
}

export interface BilingualSkill {
  kategorie?: string | null;
  kategorieEn?: string | null;
  faehigkeit?: string | null;
  faehigkeitEn?: string | null;
}

/** Der Name in der gewünschten Sprache; fehlt er, der in der anderen — nie ein leeres Feld, solange einer da ist. */
export function inLanguage(de: string | null | undefined, en: string | null | undefined, language: RequestLanguage): string {
  const [preferred, fallback] = language === 'en' ? [en, de] : [de, en];
  return (isFilled(preferred) ? preferred : isFilled(fallback) ? fallback : '') ?? '';
}

export function vocabularyName(entry: BilingualName | null | undefined, language: RequestLanguage): string {
  return inLanguage(entry?.name, entry?.nameEn, language);
}

export function skillName(skill: BilingualSkill | null | undefined, language: RequestLanguage): string {
  return inLanguage(skill?.faehigkeit, skill?.faehigkeitEn, language);
}

export function skillCategory(skill: BilingualSkill | null | undefined, language: RequestLanguage): string {
  return inLanguage(skill?.kategorie, skill?.kategorieEn, language);
}

export function compareVocabulary(a: string | null | undefined, b: string | null | undefined, language: RequestLanguage): number {
  return (a ?? '').localeCompare(b ?? '', language, {sensitivity: 'base'});
}

export function sortByDisplayName<T>(items: readonly T[], displayName: (item: T) => string, language: RequestLanguage): T[] {
  return [...items].sort((a, b) => compareVocabulary(displayName(a), displayName(b), language));
}
